import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorPage } from './ErrorPage';

function makeIncidentRef(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return `ERR-${crypto.randomUUID().slice(0, 8).toUpperCase()}`;
  }
  return `ERR-${Math.random().toString(36).slice(2, 10).toUpperCase()}`;
}

export function Page500() {
  const { t } = useTranslation();
  const incidentRef = useMemo(makeIncidentRef, []);
  return (
    <ErrorPage
      code="500"
      title={t('system.page500.title')}
      body={t('system.page500.body')}
      meta={t('system.page500.incident', { ref: incidentRef })}
      ctaLabel={t('system.page500.cta')}
      ctaTo="/"
    />
  );
}
